/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable max-lines-per-function */
import { gql, useMutation } from "@apollo/client"
import { Box, Button, Flex, Heading, Text, useToast } from "@chakra-ui/react"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router"
import { SnapLogo } from "../../components/commons/SnapLogo"
import { FormElement, formBoxStyleProps } from "../../components/commons/globalFormComponent"
import SnapFireBgWrapper from "../../components/commons/snapFireBgWrapper"
import { SubTitle } from "../../components/commons/sub-title"
import { ErrorTag } from "../../components/commons/utils"
import { LoginForm } from "./login"

const CHANGE_PASSWORD = gql`
  mutation updatePassword($token: String!, $new_password: String!) {
    updatePassword(token: $token, new_password: $new_password)
  }
`
export const ChangePassword = (): JSX.Element => {
  const [passwordMisMatch, setPasswordMisMatch] = React.useState<boolean>(false)
  const [changePassword, { data, loading: changeLoading, error: changeError }] = useMutation(CHANGE_PASSWORD)
  const toast = useToast()
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    const formElement = event.currentTarget as HTMLFormElement
    const password = formElement.password.value
    const reEnterpassword = formElement.reEnterpassword.value
    if (password !== reEnterpassword) {
      setPasswordMisMatch(true)
      formElement.password.focus()
      event.preventDefault()
      return
    }
    if (password === reEnterpassword) {
      setPasswordMisMatch(false)
    }
    const queryParameters = new URLSearchParams(window.location.search)
    const token = queryParameters.get("token")
    if (token) {
      changePassword({
        variables: { new_password: password, token }
      }).catch(() => {
        // Error handled by Apollo Client
      })
    } else {
      toast({
        title: "Error",
        description: "Invalid request - ERR02",
        status: "error"
      })
    }

    event.preventDefault()
  }

  const navigate = useNavigate()
  const navigateTo = (link: string): void => {
    navigate(link)
  }

  useEffect(() => {
    if (data) {
      toast({
        title: "Success",
        description: "Please login with your new credentials.",
        status: "success"
      })
    }
  }, [data, toast])

  useEffect(() => {
    if ((changeError && changeError.graphQLErrors.length > 0) || changeError?.message != null) {
      toast({
        title: "Error",
        description: (changeError.graphQLErrors[0] as unknown as string) ?? `Resend Error: ${changeError?.message}`,
        status: "error"
      })
    }
  }, [changeError, toast])
  const [password, setPassword] = useState<string>("")
  const [reEnterPassword, setReEnterPassword] = useState<string>("")

  return (
    <SnapFireBgWrapper pos="left" SnapFireBgWrapperProps={{ backgroundPosition: "-700px -220px", backgroundSize: "800px" }}>
      <Box w={['"330px","330px","330px"']} margin={"auto"} py="23">
        <Flex flexDir={"column"} align="center" textAlign={"center"} mt={["0px", "10px", "50px"]}>
          <SnapLogo props={{ width: ["179px", "200px", "240px"] }} />
          {/* Signup */}
          <SubTitle textProps={{ color: "white" }} boxProps={{ mb: "2", mt: ["120px", "14px", "44px"] }} value="Change your Password" />
          <Flex {...formBoxStyleProps} w="100%" pt={["25px", "10px", "25px"]}>
            {!data && (
              <>
                <form style={{ width: "255px" }} onSubmit={handleSubmit} method="post">
                  <FormElement
                    name="password"
                    type="password"
                    placeHolder="Enter new password"
                    label="New password"
                    requiredText="*"
                    htmlValidation={{ required: true }}
                    onChangeCallBack={value => {
                      setPassword(value)
                    }}
                    value={password}
                  />
                  <FormElement
                    name="reEnterpassword"
                    type="password"
                    placeHolder="Confirm your password"
                    label="Confirm password"
                    requiredText="*"
                    htmlValidation={{ required: true }}
                    onChangeCallBack={value => {
                      setReEnterPassword(value)
                    }}
                    value={reEnterPassword}
                  />
                  <Button mt={["3", 3, "10px"]} variant="Button1RegularOutline" type="submit" isLoading={changeLoading}>
                    Confirm
                  </Button>
                  <Flex justify="center" mt="24px">
                    <Text
                      color="white"
                      textDecoration="underline"
                      onClick={() => {
                        navigateTo("/homepage")
                      }}
                      cursor="pointer"
                      _hover={{ opacity: 0.8 }}
                    >
                      Cancel
                    </Text>
                  </Flex>
                </form>
                {passwordMisMatch && <ErrorTag message="Password Mismatch" />}
              </>
            )}
          </Flex>
          {data && (
            <>
              <Heading color="white" variant={"Heading1SemiBold"} m="4">
                Success!
              </Heading>
              <Text variant={"body1Regular"} color="white" mt="2">
                We&apos;ve reset your password. <br />
              </Text>
              <Text variant={"body1Regular"} color="white" mt="2">
                <strong>Login with your new credentials.</strong>
              </Text>
              <LoginForm
                hideForgotPassword={true}
                successCallBack={() => {
                  navigateTo("/")
                }}
              />
            </>
          )}
        </Flex>
      </Box>
    </SnapFireBgWrapper>
  )
}
